import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initPostHog } from "@/lib/posthog";
import { suppressThirdPartyNoise } from "@/lib/thirdPartyNoise";

// Reduce noisy third-party console errors in production (Spline config.json fetch, etc.)
suppressThirdPartyNoise();

// Initialize PostHog analytics if configured
initPostHog();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
